(function () {
  var Product = {
    carouselGlide: null,
    thumbnailGlide: null,

    init: function () {
      this.initProductCarousel();
      this.initNutritionPopup();
      this.initIngredientsToggles();
      this.initFaqAccordion();
      //this.initQuotes('.reviews .selected-reviews');
      this.initTwitterQuotes();
      this.initGlideReviews();
      this.calculateRecommendReviewsPercent();
      this.bindGlobalClicks();
    },

    bindGlobalClicks: function () {
      // Ingredients "shopnow" scroll
      document.querySelectorAll(".ingredients .shopnow").forEach(function (el) {
        if (el.dataset.shopnowInit === "true") return;
        el.dataset.shopnowInit = "true";

        el.addEventListener("click", function () {
          const title = document.querySelector(".product__title");
          if (!title) return;
          const pricingTargetOffset = title.offsetTop;
          window.scrollTo(0, pricingTargetOffset - 40);
        });
      });

      // Yotpo scroll
      var yotpoContainer = document.querySelector(".yotpo-reviews-container");
      if (yotpoContainer && yotpoContainer.dataset.yotpoInit !== "true") {
        yotpoContainer.dataset.yotpoInit = "true";
        yotpoContainer.addEventListener("click", function () {
          var target = document.querySelector(".yotpo.yotpo-main-widget");
          if (!target) return;
          Product.scrollTo(target, 500);
        });
      }
    },

    initProductCarousel: function () {
      var sliderSel = ".js--section-product__slider";
      var thumbsSel = ".js--section-product__thumbnails";

      var sliderRoot = document.querySelector(sliderSel);
      var thumbsRoot = document.querySelector(thumbsSel);

      if (!sliderRoot || !thumbsRoot) return;

      // Destroy previous instances (prevents “starts on slide 3”)
      try {
        if (this.carouselGlide) this.carouselGlide.destroy();
      } catch (e) {}
      try {
        if (this.thumbnailGlide) this.thumbnailGlide.destroy();
      } catch (e) {}

      this.carouselGlide = null;
      this.thumbnailGlide = null;

      // Hard reset any leftover transforms / active state
      var sliderTrack = sliderRoot.querySelector(".glide__track");
      var thumbsTrack = thumbsRoot.querySelector(".glide__track");
      if (sliderTrack) sliderTrack.style.transform = "";
      if (thumbsTrack) thumbsTrack.style.transform = "";

      document
        .querySelectorAll(".section-product__thumb-item--active")
        .forEach(function (el) {
          el.classList.remove("section-product__thumb-item--active");
        });

      var thumbnailsSelector = thumbsSel;

      var carouselGlide = new Glide(sliderSel, {
        type: "carousel",
        startAt: 0,
        perView: 1,
      });

      var thumbnailGlide = new Glide(thumbnailsSelector, {
        type: "carousel",
        startAt: 0,
        perView: 3,
        focusAt: 0,
        gap: 10,
      });

      this.carouselGlide = carouselGlide;
      this.thumbnailGlide = thumbnailGlide;

      var setActiveThumbnail = function (selectedIndex) {
        var activeThumbnails = document.querySelectorAll(
          ".section-product__thumb-item--active"
        );
        for (var i = 0; i < activeThumbnails.length; i++) {
          activeThumbnails[i].classList.remove(
            "section-product__thumb-item--active"
          );
        }

        var selectedThumbnails = document.querySelectorAll(
          thumbnailsSelector +
            ' .section-product__thumb-item[data-img-number="' +
            selectedIndex +
            '"]'
        );
        for (var j = 0; j < selectedThumbnails.length; j++) {
          selectedThumbnails[j].classList.add(
            "section-product__thumb-item--active"
          );
        }
      };

      carouselGlide.on("run", function () {
        if (carouselGlide.index === thumbnailGlide.index) return;
        thumbnailGlide.go("=" + carouselGlide.index);
      });

      var didUpdateThumbnailSettings = false;

      thumbnailGlide.on("build.after", function () {
        var thumbnailContainerElements = document.querySelectorAll(
          ".section-product__thumb-item"
        );
        for (var i = 0; i < thumbnailContainerElements.length; i++) {
          var thumb = thumbnailContainerElements[i];
          if (thumb.dataset.thumbInit === "true") continue;
          thumb.dataset.thumbInit = "true";

          thumb.addEventListener("click", function () {
            thumbnailGlide.go("=" + this.dataset.imgNumber);
          });
        }

        setActiveThumbnail(thumbnailGlide.index);

        if (!didUpdateThumbnailSettings) {
          setTimeout(function () {
            thumbnailGlide.update(thumbnailGlide.settings);
            didUpdateThumbnailSettings = true;
          }, 300);
        }
      });

      thumbnailGlide.on("run", function () {
        setActiveThumbnail(thumbnailGlide.index);

        var activeDot = document.querySelector(".glide__dot--active");
        if (activeDot) activeDot.classList.remove("glide__dot--active");

        var dots = document.querySelectorAll(".glide__dot");
        if (dots[thumbnailGlide.index]) {
          dots[thumbnailGlide.index].classList.add("glide__dot--active");
        }

        if (carouselGlide.index === thumbnailGlide.index) return;
        carouselGlide.go("=" + thumbnailGlide.index);
      });

      carouselGlide.mount();
      thumbnailGlide.mount();

      // Force start at 0 after mount (kills any stale index)
      carouselGlide.go("=0");
      thumbnailGlide.go("=0");
      setActiveThumbnail(0);

      this.initZoom(".js--section-product__slider-item");

      // Bind arrows once
      this.addEventListener(
        "click",
        thumbnailsSelector + " .section-product__slider-arrow-left",
        function () {
          thumbnailGlide.go("<");
        },
        "thumb_arrow_left"
      );

      this.addEventListener(
        "click",
        thumbnailsSelector + " .section-product__slider-arrow-right",
        function () {
          thumbnailGlide.go(">");
        },
        "thumb_arrow_right"
      );
    },

    initZoom: function (imgSelector) {
      if (this.isMobile()) return;

      document.querySelectorAll(imgSelector).forEach(function (galleryImg) {
        var img = galleryImg.querySelector("img");
        if (!img) return;

        Product.imageLoaded(img, function () {
          if (img.naturalWidth >= 800) {
            new ImageZoom(galleryImg, {
              fillContainer: true,
              zoomPosition: "original",
              gap: 20,
            });
          }
        });
      });
    },

    initTwitterQuotes: function () {
      if (document.querySelector(".twitter-glide .glide__track") != null) {
        if (document.querySelector(".twitter-glide")?.dataset.glideInit === "true")
          return;
        document.querySelector(".twitter-glide").dataset.glideInit = "true";
        new Glide(".twitter-glide").mount();
      }
    },

    initGlideReviews: function () {
      if (document.querySelector(".reviews-glide .glide__track") != null) {
        if (document.querySelector(".reviews-glide")?.dataset.glideInit === "true")
          return;
        document.querySelector(".reviews-glide").dataset.glideInit = "true";
        new Glide(".reviews-glide").mount();
      }
    },

    initIngredientsToggles: function () {
      document.querySelectorAll(".ingredients-list li").forEach(function (el) {
        if (el.dataset.ingInit === "true") return;
        el.dataset.ingInit = "true";

        el.addEventListener("click", function () {
          if (this.classList.contains("selected")) {
            var selectedSpan = document.querySelector(
              ".ingredients-list li.selected span"
            );
            if (selectedSpan) selectedSpan.classList.remove("close");
            this.classList.remove("selected");
          } else {
            var openSpan = document.querySelector(
              ".ingredients-list li.selected span"
            );
            if (openSpan) openSpan.classList.remove("close");

            document
              .querySelectorAll(".ingredients-list li")
              .forEach(function (li) {
                li.classList.remove("selected");
              });

            this.classList.add("selected");

            var newSelectedSpan = document.querySelector(
              ".ingredients-list li.selected span"
            );
            if (newSelectedSpan) newSelectedSpan.classList.add("close");
          }
        });
      });
    },

    initFaqAccordion: function () {
      var faqContainers = document.querySelectorAll(
        ".faq-list .faq-question-container"
      );

      faqContainers.forEach(function (el) {
        if (el.dataset.faqInit === "true") return;
        el.dataset.faqInit = "true";

        el.addEventListener("click", function (e) {
          e.stopImmediatePropagation();
          var listItem = this.closest("li");
          if (!listItem) return;

          if (listItem.classList.contains("selected")) {
            var plusIcon = this.querySelector(".accordion__plus");
            if (plusIcon) plusIcon.classList.remove("close");
            listItem.classList.remove("selected");
          } else {
            var faqList = this.closest(".faq-list");
            var openFaq = faqList ? faqList.querySelector("li.selected") : null;
            if (openFaq) {
              var openPlusIcon = openFaq.querySelector(".accordion__plus");
              if (openPlusIcon) openPlusIcon.classList.remove("close");
              openFaq.classList.remove("selected");
            }

            listItem.classList.add("selected");
            var plusIcon2 = this.querySelector(".accordion__plus");
            if (plusIcon2) plusIcon2.classList.add("close");
          }
        });
      });
    },

    initNutritionPopup: function () {
      var overlay = document.getElementById("overlay");
      var popup = document.querySelector(".ingredients-popup");
      var trigger = document.querySelector(".ingredients .button:not(.shopnow)");

      if (!overlay || !popup || !trigger) return;

      if (trigger.dataset.nutritionInit === "true") return;
      trigger.dataset.nutritionInit = "true";

      trigger.addEventListener("click", function (e) {
        e.preventDefault();

        if (overlay.dataset.overlayInit !== "true") {
          overlay.dataset.overlayInit = "true";
          overlay.addEventListener("click", function (evt) {
            evt.stopPropagation();
            popup.style.display = "none";
            overlay.style.display = "none";
          });
        }

        overlay.style.display = "inline-block";
        popup.style.display = "block";
      });

      document
        .querySelectorAll(
          ".ingredients-popup .fa-times-circle, .ingredients-popup h3"
        )
        .forEach(function (el) {
          if (el.dataset.nutritionCloseInit === "true") return;
          el.dataset.nutritionCloseInit = "true";

          el.addEventListener("click", function () {
            popup.style.display = "none";
            overlay.style.display = "none";
          });
        });
    },

    // ---- helpers (unchanged from your file) ----
    initQuotes: function (e) {
      if ($(e).hasClass("slick-initialized")) {
        $(e).slick("unslick");
      }
      $(e).slick({
        arrows: true,
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: "<i class='twitter-quotes-arrow-left'></i>",
        nextArrow: "<i class='twitter-quotes-arrow-right'></i>",
      });
    },

    imageLoaded: function (targetElements, callback) {
      this.forEachElement(targetElements, function (image) {
        if (image.tagName !== "IMG") return false;
        if (image.complete) callback();
        else image.addEventListener("load", callback);
      });
    },

    getElementsFromVar: function (elementsTarget, firstItem) {
      if (!elementsTarget) return firstItem ? undefined : [];
      if (typeof elementsTarget === "string") {
        elementsTarget = document.querySelectorAll(elementsTarget);
      }
      if (firstItem) {
        return elementsTarget instanceof HTMLElement
          ? elementsTarget
          : elementsTarget[0];
      } else {
        return elementsTarget instanceof HTMLElement
          ? [elementsTarget]
          : elementsTarget;
      }
    },

    forEachElement: function (targetElements, callback) {
      targetElements = this.getElementsFromVar(targetElements, false);
      for (let i = 0; i < targetElements.length; i++) {
        callback(targetElements[i], i);
      }
    },

    addEventListener: function (
      eventName,
      targetElements,
      callback,
      callbackName
    ) {
      targetElements = this.getElementsFromVar(targetElements, false);
      try {
        for (let i = 0; i < targetElements.length; i++) {
          if (!callbackName) {
            callbackName = "default_" + eventName + "_" + new Date().getTime();
          }
          if (!("sqEventListeners" in targetElements[i])) {
            targetElements[i].sqEventListeners = {};
          }
          if (!(eventName in targetElements[i].sqEventListeners)) {
            targetElements[i].sqEventListeners[eventName] = [];
          }

          // Prevent duplicate adds with same callbackName
          var existing = targetElements[i].sqEventListeners[eventName].some(
            function (l) {
              return l.callbackName === callbackName;
            }
          );
          if (existing) continue;

          targetElements[i].sqEventListeners[eventName].push({
            callbackName: callbackName,
            handler: callback,
          });
          targetElements[i].addEventListener(eventName, callback);
        }
      } catch (err) {
        console.error(err);
      }
    },

    offset: function (targetElements) {
      var targetElem = this.getElementsFromVar(targetElements, true);
      if (targetElem == null) return null;
      const elementRect = targetElem.getBoundingClientRect();
      return {
        top: elementRect.top + document.body.scrollTop,
        left: elementRect.left + document.body.scrollLeft,
      };
    },

    scrollTo: function (target, animationDuration, extraOffset) {
      const startYOffset = window.pageYOffset;
      if (typeof target != "number") {
        const offset = this.offset(target);
        if (offset === null) return;
        target = offset.top + startYOffset;
      }
      if (extraOffset) target += extraOffset;

      const distanceToTarget = target - startYOffset;
      if (distanceToTarget === 0) return;

      if (animationDuration == null) animationDuration = 500;

      var startTime = null;
      window.requestAnimationFrame(function scrollStep(currentTime) {
        if (startTime === null) startTime = currentTime;

        const elapsedTime = currentTime - startTime;
        if (elapsedTime >= animationDuration) {
          window.scrollTo(0, target);
          return;
        }

        const amountToScroll =
          (distanceToTarget * elapsedTime) / animationDuration;
        window.scrollTo(0, startYOffset + amountToScroll);
        window.requestAnimationFrame(scrollStep);
      });
    },

    isMobile: function () {
      return window.outerWidth <= 768;
    },

    calculateRecommendReviewsPercent: function () {
      let yoptoLoadTries = 0;

      const yotpoIntervalHandle = setInterval(() => {
        const yotpoRatingSpan = document.querySelector(
          ".yotpo-sr-bottom-line-left-panel.yotpo-sr-bottom-line-score"
        );
        if (yotpoRatingSpan == null) {
          yoptoLoadTries++;
          if (yoptoLoadTries > 5) clearInterval(yotpoIntervalHandle);
          return;
        }

        clearInterval(yotpoIntervalHandle);

        const yotpoStarRating = parseFloat(yotpoRatingSpan.innerText);
        const recommendedPercent = Math.trunc((yotpoStarRating / 5) * 100);

        const label = document.querySelector(
          ".reviews-recommend-percent-label-container"
        );
        const value = document.querySelector(
          ".reviews-recommend-percent-value-container"
        );

        if (!label || !value) return;

        label.style.display = recommendedPercent < 86 ? "none" : "block";
        value.innerHTML = recommendedPercent;
      }, 600);
    },
  }; // end Product

  window.initProduct = Product;

  function initPDP() {
    Product.init();

    // Retry FAQ init (your old behavior, but safe)
    setTimeout(function () {
      if (
        document.querySelector(".faq-list") &&
        document.querySelectorAll(".faq-list .faq-question-container").length > 0
      ) {
        Product.initFaqAccordion();
      }
    }, 1000);
  }

  document.addEventListener("DOMContentLoaded", initPDP);
  document.addEventListener("pdp:swapped", initPDP);
})();